var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUndo = function SvgUndo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5c34cd",
    d: "M1.375 1.25A.38.38 0 0 0 1 1.625v6c0 .219.156.375.375.375h6a.38.38 0 0 0 .375-.375v-.844c0-.218-.187-.375-.406-.375L3.406 6.5C4.375 4.375 6.5 2.875 9 2.875A6.135 6.135 0 0 1 15.125 9 6.115 6.115 0 0 1 9 15.125c-1.594 0-3-.562-4.094-1.531-.156-.125-.375-.125-.5 0l-.625.625a.396.396 0 0 0 0 .562A7.87 7.87 0 0 0 9 16.75c4.25 0 7.719-3.437 7.75-7.719 0-4.25-3.469-7.75-7.75-7.75A7.64 7.64 0 0 0 2.531 4.72l.063-3.063c0-.218-.156-.406-.375-.406z"
  })));
};
export default SvgUndo;